import ForgotPassword from './ForgotPassword.jsx';

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/components/modules/forgot-password/index.js